import React from 'react';
import styled from 'styled-components';
import { IconPin as IconPinMisc } from '../Misc/Pin';
const Wrapper = styled.div `
  position: relative;

  &:before {
    content: '';
    display: block;
    width: 24px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    bottom: -70%;
    left: 50%;
    opacity: var(--pin-icon-circle-opacity, 0);
    background-color: ${({ theme }) => theme.primary.background};
    transform: translate(-50%, -70%) scale(var(--pin-icon-circle-scale, 0)) translateZ(0);
  }
`;
const Pin = styled(IconPinMisc) `
  transform: translateY(var(--pin-icon-y, 0px)) scale(var(--pin-icon-scale-x, 1), var(--pin-icon-scale-y, 1))
    rotate(var(--pin-icon-rotate, 0deg));
  transform-origin: 50% 90%;
`;
export const IconPin = ({ className }) => {
    return (React.createElement(Wrapper, { className: className },
        React.createElement(Pin, null)));
};
//# sourceMappingURL=Pin.js.map